var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.416 0.75H0.916016C0.501172 0.75 0.166016 1.08516 0.166016 1.5V16.5C0.166016 16.9148 0.501172 17.25 0.916016 17.25H20.416C20.8309 17.25 21.166 16.9148 21.166 16.5V1.5C21.166 1.08516 20.8309 0.75 20.416 0.75ZM19.4785 5.625H14.5098V2.4375H19.4785V5.625ZM19.4785 10.875H14.5098V7.125H19.4785V10.875ZM8.32227 7.125H13.0098V10.875H8.32227V7.125ZM13.0098 5.625H8.32227V2.4375H13.0098V5.625ZM1.85352 7.125H6.82227V10.875H1.85352V7.125ZM1.85352 2.4375H6.82227V5.625H1.85352V2.4375ZM1.85352 12.375H6.82227V15.5625H1.85352V12.375ZM8.32227 12.375H13.0098V15.5625H8.32227V12.375ZM19.4785 15.5625H14.5098V12.375H19.4785V15.5625Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoll);
export default __webpack_public_path__ + "static/media/roll.a5910529107cbfa34ef98e68ba7e3e0c.svg";
export { ForwardRef as ReactComponent };